import { DateTime } from 'luxon'

import { Identification } from './identification'

export type Person = Nullable<{
  name: string
  firstLastName: string
  secondLastName: string
  birthDate: Date
  gender: PropsTypesOf<typeof GenderEnum>['code']
}> & {
  identification: Identification
}

function load(model?: Partial<Person> | null): Person {
  return {
    identification: model?.identification ?? Identification.load(),
    name: model?.name ?? null,
    firstLastName: model?.firstLastName ?? null,
    secondLastName: model?.secondLastName ?? null,
    birthDate: model?.birthDate ?? null,
    gender: model?.gender ?? null,
  }
}

function getFullName(model?: Person | null) {
  if (!model) return
  const { name, firstLastName, secondLastName } = model
  if (!name && !firstLastName && !secondLastName) return null
  const validComponents = [name, firstLastName, secondLastName].filter(Boolean)
  const fullName = validComponents.join(' ')
  return fullName
}

function getAge(birthDate?: Date | null) {
  if (isNil(birthDate)) return null
  const _birthDate = DateTime.fromJSDate(birthDate)

  const now = DateTime.now()

  const age = Math.floor(now.diff(_birthDate, 'years').years)

  return age
}

export const GenderEnum = {
  Masculine: { label: 'Masculino', code: 'Masculine', accronym: 'M' },
  Feminine: { label: 'Femenino', code: 'Feminine', accronym: 'F' },
  Unknown: { label: 'Otro', code: 'Unknown', accronym: 'U' },
} as const

function getGenderTypeList(omitOther = false) {
  const list = Object.values(GenderEnum)
  if (omitOther) return list.filter((x) => x !== GenderEnum.Unknown)
  return Object.values(GenderEnum)
}

export const Person = {
  load,
  getFullName,
  getAge,
  getGenderTypeList,
}
